const COLORS = ["#e23b3b", "#c9a8e4", "#f0cbb8", "#f6d365", "#8d5bb8", "#fff", "#5d8f72"];

function bits() {
  return Array.from({ length: 96 }, (_, i) => ({
    left: (i * 17 + (i % 7) * 9) % 100,
    delay: (i % 12) * 0.08,
    dur: 2.1 + (i % 8) * 0.18,
    color: COLORS[i % COLORS.length],
    w: 6 + (i % 5),
    rot: (i * 37) % 360,
  }));
}

export function Confetti() {
  return (
    <div className="sg-confetti" aria-hidden="true">
      {bits().map((b, i) => (
        <i
          key={i}
          style={{
            left: `${b.left}%`,
            width: b.w,
            height: b.w * 0.55,
            background: b.color,
            animationDelay: `${b.delay}s`,
            animationDuration: `${b.dur}s`,
            transform: `rotate(${b.rot}deg)`,
          }}
        />
      ))}
    </div>
  );
}
